import { types } from '../types/types';

export const login = (user: string, data: unknown[]) => ({
	type: types.login,
	payload: {
		user,
		data,
	},
});

export const logout = () => ({
	type: types.logout,
});
